import styled from 'styled-components'
import { themeStyles } from '../../../styles/theme'

export const StyledAmountWrapper = styled.div`
  color: ${themeStyles.colors.accentColors.secondary.main};
  cursor: pointer;

  @media (max-width: 320px) {
    display: none;
  }
`
